import { logger } from "../../../shared/logger";
import type { RefundMatchedRequest } from "../terminal-refund";
import { render } from "./refund-matched/render";
import { usePosConnectorState } from "./refund-matched/use-pos-connector-state";

export namespace RefundMatched {
	export type Props = {
		request: RefundMatchedRequest;
	};
}

export function RefundMatched({ request }: RefundMatched.Props) {
	const page = usePosConnectorState({ request });
	logger.debug("refund: matched render", { state: page });
	return render({ page });
}
